import React from 'react'
import image from './thanks.png'

import './largeImage.scss'

export default () => <div style={{position: 'relative'}}>
  <img src={image} />
</div>